var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Load `ast.js` library
 *
 * @param useSimple - Flag to determine which version to load
 * - loads "https://acdn.adnxs-simple.com/ast/ast.js" if true
 * - loads "https://acdn.adnxs.com/ast/ast.js" if false
 */
export const loadAPNTag = (useSimple) => {
    const src = `https://acdn.adnxs${useSimple ? '-simple' : ''}.com/ast/ast.js`;
    const script = Object.assign(document.createElement('script'), { src, async: true });
    (document.head || document.body).appendChild(script);
};
/**
 * Wait for `ast.js` library load.
 *
 * @param timeout - milliseconds to reject the promise if ast hasn't loaded
 *
 * @returns A promise which resolves with TAPNTagLoaded
 */
export const awaitAPTNTag = (timeout = 30000) => new Promise((resolve, reject) => {
    setTimeout(reject, timeout);
    globalThis.apntag = globalThis.apntag || { anq: [] };
    globalThis.apntag.anq.push(() => resolve(globalThis.apntag));
});
/**
 * Load `ast.js` if not loaded and return promise to wait for it's load
 *
 * @params useSimple - which `ast.js` version to use (adnxs.com or adnxs-simple.com)
 * @params timeout - milliseconds to reject the promise if ast.js hasn't loaded
 *
 * @returns A promise which resolves to `TAPNTagLoaded`
 */
export const loadAndWaitAPNTag = (useSimple_1, ...args_1) => __awaiter(void 0, [useSimple_1, ...args_1], void 0, function* (useSimple, timeout = 30000) {
    loadAPNTag(useSimple);
    return awaitAPTNTag(timeout);
});
